import React, { useContext, useEffect, useId, useLayoutEffect, useRef, useState } from 'react';
import { ScriptLoaderContext } from '../../utils/ScriptLoaderProvider';

export const useKakaoMap = (
  containerStyle: React.CSSProperties = { width: '100%', height: '400px' },
  center?: { x: number; y: number },
  zoomLevel = 3,
): { map: JSX.Element; mapRef: React.MutableRefObject<any>; mapReady: boolean } => {
  const id = useId();
  const map = useRef<any>();
  const { kakaoLoaded } = useContext(ScriptLoaderContext);
  const [mapReady, setMapReady] = useState(false);

  useLayoutEffect(() => {
    if (!kakaoLoaded || !center || mapReady) return;
    initialiseStaticMap();
  }, [kakaoLoaded]);

  useLayoutEffect(() => {
    if (!map.current || !center) return;
    map.current.setCenter(new window.kakao!.maps.LatLng(center!.y, center!.x));
  }, [center]);

  const initialiseStaticMap = () => {
    const coords = new window.kakao!.maps.LatLng(center!.y, center!.x);
    const mapOption = {
      center: coords,
      level: zoomLevel,
      marker: coords,
    };

    const mapContainer = document.getElementById(id);
    map.current = new window.kakao!.maps.StaticMap(mapContainer, mapOption);

    setMapReady(true);
  };

  useEffect(() => {
    if (map.current) {
      map.current.setLevel(zoomLevel);
    }
  }, [zoomLevel]);

  return {
    map: <div id={id} style={containerStyle}></div>,
    mapRef: map,
    mapReady,
  };
};
